<template>
  <div style=" background-color: #212f52; height: content-box">
    <div style="height: 70px;display: flex;align-items: center;" class="topInfo">
      <img src="../../assets/Python.png" width="40px" height="40px" style="margin-left: 20px">
      <div style="font-size: 18px; margin-left: 10px; color: white"> Python函数参数传递可视化虚拟仿真实验</div>
    </div>
    <el-main style="font-size: 12px; ">
      <el-tabs v-model="activeName">
        <el-tab-pane v-for="item in pageData" :key="item.id" :label="item.name" :name="item.name">
          <component :is="item.content" :itemData="item.data" v-if="activeName === item.name"></component>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </div>
</template>

<script>
import sz01 from "./sz01.vue";
import sz02 from "./sz02.vue";
import sz03 from "./sz03.vue";
export default {
  data() {
    return {
      activeName: "猜字游戏",
      pageData: [
        {
          id: "t01",
          name: "猜字游戏",
          content: "sz01",
          data: "猜字游戏"
        },
        {
          id: "t02",
          name: "2048游戏",
          content: "sz02",
          data: "2048游戏"
        },
        {
          id: "t03",
          name: "加密和解密",
          content: "sz03",
          data: "加密和解密"
        }
      ]
    }
  },
  components: {
    sz01,
    sz02,
    sz03
  },
  props: ["itemData"]
};
</script>

<style lang="less" scoped>
  .topInfo {
    background-image: url("../../assets/topbg.png");
  }
  .el-main {
    padding-top: 10px;
  }

  /deep/ .el-tabs__item {
    color: white;
  }
  /deep/ .el-tabs__item.is-active {
    color: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/lw/index03.vue